'use strict';

var clickButton = function() {
    var output = '';
    var count = 0;
    $('#spades, #clubs, #diamonds, #hearts, #jokers').children().each(function() {
        if ($(this).is(':checked')) {
            if (output !== '') {
                output += ',';
            }
            output += this.id;
            count += 1;
            console.log(output)
        }
    });
    $('#count').html(count);
    if (count!==9) {
        for (var suit in ['spades','diamonds','hearts', 'clubs']) {
            $('#'+ suit +'advice').html('');
        }
        $('#advice').html('Click ' + (9-count) + '  more cards');
    } else {
        $('#advice').html('Calculating...');
        var start = new Date().getTime();
        // ajax request then update result
        var val = {};
        val.hand = output;
        // $.getJSON('http://www.clayweidinger.com/jpitch.php?hand='+encodeURI(output)+'&callback=?', {}, function(data) {
        // $.getJSON('http://www.clayweidinger.com/grpitch/getBid/index?hand='+encodeURI(output)+'&callback=?', {}, function(data) {
        // $.getJSON('http://127.0.0.1:3000/pitch-bid?hand='+encodeURI(output)+'&callback=?', {}, function(data) {
        $.getJSON('https://j0iycbqgn3.execute-api.us-east-1.amazonaws.com/Prod/pitch-bid/?hand='+encodeURI(output)+'&callback=?', {}, function(data) {
            $('#advice').html('results in ' +  ((new Date().getTime() - start)/1000) + 's');
            for (var suit in data.advice) {
                var msg = '';
                for (var bid in data.advice[suit]) {
                    msg += 'A ' + bid + ' bid will win ~'+ data.advice[suit][bid].percentWon + '% of deal, averaging ' + data.advice[suit][bid].averagePointsGained + ' points per game.<br>';
                }
                $('#'+ suit.toLowerCase() +'advice').html(msg);
            }
        });
    }
};

$(function() {
    $('#year').text(new Date().getYear() + 1900);

    $('.btn').button();

    $('.btn').click(function() { setTimeout(clickButton, 50);  });
  
    $('#clear').click(function() {
      $('#spades, #clubs, #diamonds, #hearts, #jokers').children().each(function(){
        if ($(this).is(':checked')) {
            $(this).prop("checked", false);
        }
      });
      $('#advice').html('Click 9 more cards');
      var s, suits = ['hearts', 'spades', 'diamonds', 'clubs'];
      for (s = 0; s < suits.length; s += 1) {
        $('#'+ suits[s] +'advice').html('');
      }
    });

    // var i = 0;
    // $('.btn').each(function() {
    //     if (i < 8) { $(this).addClass('active'); }
    // 	else if (i === 9) { $(this).trigger('click'); }
    //     i++;
    // });
});

